import { Button } from 'react-bootstrap'
import React from 'react'

interface Props {
  text: string,
  loading?: boolean,
  type?: 'reset' | 'button' | 'submit' | undefined
  className?: string
  onClick?: () => void
}

export default function LoadingButton({
  text,
  loading = false,
  type = 'button',
  className,
  onClick
}: Props) {
  return(
    <Button onClick={onClick} variant="primary" type={type} disabled={loading} className={className}>
      {loading ? <i className="fa-solid fa-spinner fa-spin me-2" /> : null}
      {text}
    </Button>
  )
}
